module.exports = __webpack_public_path__ + "img/symbol_5.28c8dddb.png";